import React, { useEffect, useState } from "react";
import {
  Alert,
  AlertDescription,
  AlertIcon,
  Button,
  Icon,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { CloudArrowUp } from "@phosphor-icons/react";
import cr from "../../lib/request";
import useTrigger from "../../globalState/useTrigger";
import { Course } from "../../const/types";

type Props = {
  course: Course;
};

export default function PublishCourseModal({ course }: Props) {
  const [loading, setLoading] = useState<boolean>(false);
  const toast = useToast();
  const { trigger, setTrigger } = useTrigger();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [data, setData] = useState<number | null>(null);

  useEffect(() => {
    if (course.id) {
      setLoading(true);
      const url = `api/course/${course.id}/onlinestatus`;
      cr.get(url)
        .then((r) => {
          if (r.status === 200) {
            setData(r.data.data);
          }
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [course.id]);

  const [counter, setCounter] = useState(10);

  useEffect(() => {
    if (isOpen && counter > 0) {
      const timer = setTimeout(() => {
        setCounter((prevCounter) => prevCounter - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [isOpen, counter]);

  const onUpdateStatus = () => {
    setLoading(true);
    const url = `api/course/${course.id}/updateonlinestatus`;
    cr.post(url)
      .then((r) => {
        if (r.status === 200) {
          toast({
            title: r.data.message,
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          setTrigger(!trigger);
        }
      })
      .catch((e) => {
        console.log(e);
        toast({
          title: e.response?.data?.message,
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <Button
        leftIcon={<Icon as={CloudArrowUp} fontSize={20} />}
        colorScheme="ap"
        size={"sm"}
        className="clicky"
        variant={"outline"}
        onClick={onOpen}
        isLoading={loading}
        isDisabled={data ? true : false}
      >
        Publikasi
      </Button>

      <Modal
        isOpen={isOpen}
        onClose={() => {
          onClose();
          setCounter(10);
        }}
      >
        <ModalOverlay />

        <ModalContent>
          <ModalHeader>Publikasi Course</ModalHeader>

          <ModalBody>
            <Alert
              status="warning"
              variant="left-accent"
              alignItems={"flex-start"}
              mb={2}
            >
              <AlertIcon mt={1} />
              <AlertDescription>
                Anda akan mempublikasikan course ini.{" "}
                <b>
                  Anda tidak akan bisa menambahkan silabus lagi dan course tidak
                  bisa ditarik menjadi offline.{" "}
                </b>
                Pastikan Anda telah menyelesaikan semua persiapan sebelum
                mempublikasikan course. Apakah Anda yakin ingin melanjutkan?
              </AlertDescription>
            </Alert>

            <Text opacity={0.5} fontSize={"small"}>
              Anda masih bisa menghapus course, dan penghapusan ini tidak
              permanen. Course yang telah dihapus bisa dipulihkan kembali
              melalui menu <b>Restore</b>.
            </Text>
          </ModalBody>

          <ModalFooter gap={2}>
            <VStack align={"stretch"} w={"100%"}>
              <Button
                onClick={onUpdateStatus}
                colorScheme="ap"
                className="clikcy"
                isDisabled={counter ? true : false}
                w={"100%"}
                isLoading={loading}
              >
                {counter ? `Tunggu ${counter} detik` : "Publikasi"}
              </Button>

              <Button
                onClick={() => {
                  onClose();
                  setCounter(10);
                }}
                className="btn-clear"
                h={"20px"}
                mt={2}
              >
                Batal
              </Button>
            </VStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
